package com.example.mystybag.sharedmodels.project.requestModels.favorites

import com.example.mystybag.sharedmodels.AllCommands.REMOVE_FAVORITE
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
class RemoveFavoriteRequestModel(
    val userId            : Long,
    val merchantLocationId: Long
): BaseRequestModel(api = REMOVE_FAVORITE)